import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";

/** An absent basis reads as cash, the basis a ledger defaults to. */
export function getAccountingBasisLabel(
    basis: AccountingLedgerBasis | null | undefined,
): string {
    return basis === AccountingLedgerBasis.accruals ? "Accrual" : "Cash";
}
